<div class="about">
  <div class="company">
    <div class="title">
      <!-- Please make sure to search throughout source code to update all occurrences of this title! -->
      <div class="title">
        <img src="{{ dataSource.logoPath }}" alt="VIAVI logo" /> / {{ dataSource.title }}
      </div>
    </div>

    <div class="version">
      <div class="title">Version</div>
      <div>{{ dataSource.version }}</div>
    </div>

    <div class="contact">
      <div class="title">Contact us</div>
      <u><a href="http://www.viavisolutions.com/" target="_blank">Visit our website</a></u>
      <div>
        Email us at
        <u
          ><a
            [href]="
              dataSource?.isActiveTest
                ? 'mailto:customer.care@viavisolutions.com'
                : 'mailto:nisupport@viavisolutions.com'
            "
            >{{
              dataSource?.isActiveTest
                ? 'customer.care@viavisolutions.com'
                : 'nisupport@viavisolutions.com'
            }}</a
          ></u
        >
      </div>
    </div>

    <div class="services">
      <div class="title">Third party services</div>
      <div class="description">
        All product names, logos, and brands are property of their respective owners. All company,
        product, and service names used in {{ dataSource.title }} are for identification purposes
        only. Use of these names, logos, and brands does not imply endorsement.
      </div>
    </div>

    <div class="licenses">
      <div class="title">Third party licenses</div>
      <ul>
        <li *ngFor="let license of dataSource.licenseData | keyvalue">
          <a href="{{ license.value }}" target="_blank">{{ license.key }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>
